// @flow

import * as React from 'react';
import { Alert, Base } from '@gandi/ui';
import { useTranslator } from '@gandi/translate';

const AlertError = (): React.Element<typeof Base> => {
  const { __ } = useTranslator();

  return (
    <Base marginBottom="base">
      <Alert
        intent="danger"
        message={__('An error has occurred, please try again.')}
      />
    </Base>
  );
};

export default AlertError;
